import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { AuthStatus, UserState } from '@app/auth/user.state';
import { EnvironmentService } from '@app/shared/environment.service';

export const authGuard: CanActivateFn = (): UrlTree | boolean | Observable<UrlTree | boolean> => {
  const userState = inject(UserState);
  const router = inject(Router);
  const environmentService = inject(EnvironmentService);

  if (userState.user()) {
    return true;
  }

  userState.refreshCurrentUser$.next();
  return toObservable(userState.authStatus).pipe(
    filter((status) => status !== AuthStatus.Pending),
    take(1),
    map((status) => {
      if (status === AuthStatus.Success) {
        return true;
      }
      userState.updateReturnTo$.next(environmentService.currentLocation);
      return router.parseUrl('/u/login');
    }),
  );
};
